module.exports = __webpack_public_path__ + "sc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/sc.svg
// module id = 1047
// module chunks = 0